import { render, staticRenderFns } from "./WidgetIntegration.vue?vue&type=template&id=7e0ff928&scoped=true"
import script from "./WidgetIntegration.vue?vue&type=script&lang=js"
export * from "./WidgetIntegration.vue?vue&type=script&lang=js"
import style0 from "./WidgetIntegration.vue?vue&type=style&index=0&id=7e0ff928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0ff928",
  null
  
)

export default component.exports